import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import helpHubService from '../services/helpHubService';

const FrillSSOPage: React.FC = () => {
  const { user, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const handleSSO = async () => {
      // Get redirect URL from query params
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect') || 'https://roadmap.dashboardfox.com';

      // Wait for auth to finish loading
      if (loading) return;

      // Check for token in localStorage as backup
      const token = localStorage.getItem('accessToken');
      const hasAuth = !!user || !!token;

      if (!hasAuth) {
        // Not logged in - redirect to login with return URL
        const returnUrl = encodeURIComponent(window.location.href);
        window.location.href = `/auth?returnTo=${returnUrl}`;
        return;
      }

      try {
        // Get Frill token from API
        const tokenData = await helpHubService.getFrillToken();
        
        // Redirect to Frill with SSO token
        const separator = redirect.includes('?') ? '&' : '?';
        window.location.href = `${redirect}${separator}ssoToken=${tokenData.token}`;
      } catch (err) {
        console.error('Frill SSO error:', err);
        setError('Failed to authenticate. Redirecting...');
        setProcessing(false);
        setTimeout(() => {
          window.location.href = redirect;
        }, 2000);
      }
    };

    handleSSO();
  }, [!!user, loading]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '16px',
    }}>
      {error ? (
        <p style={{ color: '#e53e3e' }}>{error}</p>
      ) : (
        <>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e2e8f0',
            borderTopColor: '#3182ce',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }} />
          <p>Authenticating with roadmap...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </>
      )}
    </div>
  );
};

export default FrillSSOPage;
